<template>
  <button @click="onClick" :class="[buttonClass]" v-text="buttonText"></button>
</template>

<script>
export default {
  props: {
    buttonClass: {
      required: true,
      type: String,
    },
    buttonText: {
      required: true,
      type: String,
    },
    action: {
      type: String,
      required: true,
    },
    data: {
      required: false,
    },
    method: {
      required: false,
      type: String,
      default: "post",
    },
    endpoint: {
      required: false,
      type: String,
    },
    params: {
      required: false,
    },
    message: {
      required: false,
      type: String,
    },
  },
  data() {
    return {};
  },

  methods: {
    onClick() {
      let action = this.action;
      let data = this.data;
      let method = this.method;
      let endpoint = this.endpoint;
      let params = this.params;
      let message = this.message;

      //   console.log(`Action: ${action}`);
      //   console.log(data);
      //   console.log(config);

      // TODO: Check if config.route and config.message is set

      if (action == "confirm") {
        Bus.$emit("confirmModal", {
          method: method ? method : "post",
          route: endpoint,
          params: params ? params : null,
          message: message,
        });
      } else if (action == "removed") {
        Bus.$emit("removedModal", {
          method: method ? method : "post",
          route: endpoint,
          params: params ? params : null,
          message: message,
        });
      } else if (action == "logs") {
        if (_.hasIn(data, "routes.logs")) {
          window.location.href = data.routes.logs;
        }
      }
    },
  },
};
</script>
